import * as type from './constant';

export const getPositionClass = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getPositionClassSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getPositionClassError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addPositionClass = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addPositionClassSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updatePositionClass = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updatePositionClassSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deletePositionClass = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deletePositionClassSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationPositionClassError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
